import { useRef, useEffect, forwardRef, useState } from 'react';

import styles from './NoteAreaComponent.module.css';

const NoteAreaComponent = forwardRef((props, ref) => {
    var {
        onFocus, onBlur, focused = false, value, keyboardOpenAt, onChange, keyboardRef, placeHolder,
        width, height, onEnterClicked,
    } = props;

    const caretPosition = useRef();
    const currentKeyboard = useRef();
    const lastValue = useRef();
    const componentInstance = useRef(null);

    const [keyboardClicked, setKeyboardClicked] = useState(false);

    useEffect(() => {
        ref.current.value = value;
    }, [value])


    useEffect(() => {
        componentInstance.current = ref.current;
        ref.current.value = value;
        lastValue.current = "";

        ref.current.keyboardOpenAt = keyboardOpenAt;
        ref.current.setKeyboardClicked = () => {
            setKeyboardClicked(true);
        };

        ref.current.enterClicked = () => {
            if (!caretPosition.current) {
                caretPosition.current = ref.current.selectionStart;
            }
            ref.current.value = ref.current.value.substring(0, caretPosition.current) + '\n' + ref.current.value.substring(caretPosition.current);
            caretPosition.current = caretPosition.current + 1;

            ref.current.selectionStart = caretPosition.current;
            ref.current.selectionEnd = caretPosition.current;
        };

        ref.current.addToValue = (key) => {

            setKeyboardClicked(true);

            let start = ref.current.selectionStart;
            let end = ref.current.selectionEnd;

            const newValue = ref.current.value.slice(0, start) + key + ref.current.value.slice(end);
            ref.current.value = newValue;
            const newCursorPosition = start + key.length;
            ref.current.setSelectionRange(newCursorPosition, newCursorPosition);

            const inputEvent = new Event('input', { bubbles: true });
            ref.current.dispatchEvent(inputEvent);

            onTextChanged();
        };

        ref.current.removeOneFromValue = () => {
            setKeyboardClicked(true);

            let start = ref.current.selectionStart;
            let end = ref.current.selectionEnd;

            if (start === end) {
                if (start > 0) {
                    const newValue = ref.current.value.slice(0, start - 1) + ref.current.value.slice(end);
                    ref.current.value = newValue;
                    ref.current.setSelectionRange(start - 1, start - 1);
                }
            } else {
                const newValue = ref.current.value.slice(0, start) + ref.current.value.slice(end);
                ref.current.value = newValue;
                ref.current.setSelectionRange(start, start);
            }

            const inputEvent = new Event('input', { bubbles: true });
            ref.current.dispatchEvent(inputEvent);

            onTextChanged();
        };

        if (focused) {
            ref.current.focus();
        }

        currentKeyboard.current = keyboardRef.current;

        setTimeout(() => {
            keyboardRef.current?.addInputElement(ref.current);

        }, 100)

        return () => {
            currentKeyboard.current?.removeInputElement(componentInstance.current);
        }
    }, [])

    useEffect(() => {
        if (focused) {
            setTimeout(() => {
                ref.current.focus();
            }, 100)
        }
    }, [focused])

    const onTextChanged = () => {
        if (onChange) {
            if (lastValue.current !== ref.current.value) {
                onChange?.(ref.current?.value);
                lastValue.current = ref.current.value;
            }
        }
    }

    const onKeyUp = (e) => {
        if (e.key === 'Enter' && e.shiftKey) {
            console.log('Shift + Enter detected');
        } else if (e.key === 'Enter') {
            onEnterClicked?.();
        }
    }

    return (
        <div style={{ width: width, height: height, position: "relative" }}>
            <textarea
                ref={ref}
                step={0.1}
                className={styles.notesArea}
                placeholder={placeHolder}
                onKeyUp={(e) => onKeyUp(e)}
                onFocus={() => {
                    if (!keyboardClicked) {
                        if (keyboardRef.current)
                            keyboardRef.current.setInputElement(ref.current);
                    }
                    onFocus?.();
                    setKeyboardClicked(false);
                }}
                onBlur={() => {
                    caretPosition.current = ref.current.selectionStart;
                    if (!keyboardClicked) {
                        keyboardRef.current.setInputElement(null);
                        onBlur?.();
                    } else {
                        ref.current.focus();
                    }
                }}
                onChange={onTextChanged}
            />
        </div>
    );
})

export default NoteAreaComponent;

